import React from "react";
import { Col, Row } from "react-bootstrap";
import { Title } from "../../../library/title";
import "./style.scss";

const Index = () => {
  return (
    <div className="help-center-menu-container">
      <div className="inner-help-center-menu-container">
        <Title size="regular">Flere kanaler</Title>
        <div className="single-option-container">
          <Row className="single-option-row">
            <Col className="icon-col my-auto">
              <i class="fab fa-instagram"></i>
            </Col>
            <Col className="text-col">
              <h5 className="subtitle">Instagram</h5>
              <p className="description">
                Følg oss på vår offisielle Instagram-side{" "}
                <a href="https://www.instagram.com/leadsurfapp/">her</a>.
              </p>
            </Col>
          </Row>
          <Row className="single-option-row">
            <Col className="icon-col my-auto">
              <i class="fab fa-facebook-f"></i>
            </Col>
            <Col className="text-col">
              <h5 className="subtitle">Facebook</h5>
              <p className="description">
                Lik og kom i kontakt med oss på Facebook{" "}
                <a href="https://www.facebook.com/leadsurfapp">her</a>.
              </p>
            </Col>
          </Row>
          <Row className="single-option-row">
            <Col className="icon-col my-auto">
              <i class="fal fa-envelope-open-text"></i>
            </Col>
            <Col className="text-col">
              <h5 className="subtitle">E-post</h5>
              <p className="description">
                Send oss en e-post på{" "}
                <a href="mailto:kontakt@leadfind.no">kontakt@leadfind.no</a>.
              </p>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Index;
